// import { IWeeksDay } from "../types/student.interface";

export function htmlToMongo(timing?: any) {
  if (!timing) return undefined;
  return {
    close: timing.close,
    entranceTime: new Date(
      `1999-03-17T${
        timing?.entranceTime?.hour ? timing?.entranceTime?.hour : "00"
      }:${
        timing?.entranceTime?.minute ? timing?.entranceTime?.minute : "00"
      }:00.000Z`
    ),
    departTime: new Date(
      `1999-03-17T${
        timing?.departTime?.hour ? timing?.departTime?.hour : "00"
      }:${
        timing?.departTime?.minute ? timing?.departTime?.minute : "00"
      }:00.000Z`
    ),
    pickupTime: new Date(
      `1999-03-17T${
        timing?.pickupTime?.hour ? timing?.pickupTime?.hour : "00"
      }:${
        timing?.pickupTime?.minute ? timing?.pickupTime?.minute : "00"
      }:00.000Z`
    ),
  };
}

export function mongoToHtml(data: any) {
  if (!data) return undefined;
  const timing: any = {
    close: data?.close ? data?.close : false,
    entranceTime: {
      hour: data?.entranceTime
        ? data?.entranceTime?.substr(11, 2)?.padStart(2, "0") |
          data?.entranceTime
        : "00",
      minute: data?.entranceTime
        ? data?.entranceTime?.substr(14, 2)?.padStart(2, "0") |
          data?.entranceTime
        : "00",
    },
    departTime: {
      hour: data?.departTime
        ? data?.departTime?.substr(11, 2)?.padStart(2, "0") | data?.departTime
        : "00",
      minute: data?.departTime
        ? data?.departTime?.substr(14, 2)?.padStart(2, "0") | data?.departTime
        : "00",
    },
    pickupTime: {
      hour: data?.pickupTime
        ? data?.pickupTime?.substr(11, 2)?.padStart(2, "0") | data?.pickupTime
        : "00",
      minute: data?.pickupTime
        ? data?.pickupTime?.substr(14, 2)?.padStart(2, "0") | data?.pickupTime
        : "00",
    },
  };
  return timing;
}
